import { lazy, Suspense } from 'react';
import { Box } from '@chakra-ui/react';

const TiptapEditorComponent = lazy(() =>
   import('./tiptap').then(module => ({ default: module.TiptapEditor }))
);

export const TiptapEditor = (props: any) => (
   <Suspense
      fallback={
         <Box
            id={props.editorid}
            className="ProseMirror-menubar-wrapper"
            minHeight="150px"
            bg="gray.50"
            border="1px solid"
            borderColor="gray.200"
            borderRadius="md"
         />
      }
   >
      <TiptapEditorComponent {...props} />
   </Suspense>
);
